const BASE_LAYERS = [
  {
    key: "route",
    label: "Jalur Fleet Order",
  },
  {
    key: "stops",
    label: "Titik Pengiriman",
  },
  {
    key: "depots",
    label: "Depot & Gudang",
  },
];

export function defaultLayerVisibility(categories = []) {
  return {
    route: true,
    stops: true,
    depots: true,
    ...Object.fromEntries(
      categories.map((category) => [
        `poi:${category.value}`,
        category.value === "HOTEL",
      ]),
    ),
  };
}

function countActiveLayers(categories, layers) {
  const activeBaseLayers = BASE_LAYERS.filter(
    (layer) => layers[layer.key] !== false,
  ).length;

  const activePoiLayers = categories.filter(
    (category) => layers[`poi:${category.value}`] === true,
  ).length;

  return activeBaseLayers + activePoiLayers;
}

export function MapLayerControl({
  categories = [],
  collapsed = true,
  layers,
  onToggleCollapsed,
  onToggleLayer,
  poiSummary = {},
}) {
  const activeLayerCount = countActiveLayers(categories, layers);
  const poiCount = Number(poiSummary.totalVisible) || 0;

  return (
    <section
      className={`map-layer-panel ${
        collapsed ? "map-layer-panel--collapsed" : ""
      }`.trim()}
      aria-label="Kontrol layer peta"
    >
      <button
        aria-controls="fleet-map-layer-options"
        aria-expanded={!collapsed}
        className="map-layer-panel__toggle"
        onClick={onToggleCollapsed}
        type="button"
      >
        <span className="map-layer-panel__heading">
          <strong>Layer Peta</strong>

          <small>
            {activeLayerCount} layer aktif · {poiCount} POI area rute
          </small>
        </span>

        <span
          aria-hidden="true"
          className="map-layer-panel__chevron"
        >
          ⌃
        </span>
      </button>

      <div
        aria-hidden={collapsed}
        className="map-layer-panel__collapse"
        id="fleet-map-layer-options"
      >
        <div className="map-layer-panel__body">
          <div className="map-layer-panel__group">
            {BASE_LAYERS.map((layer) => (
              <label
                className="map-layer-toggle"
                key={layer.key}
              >
                <input
                  checked={layers[layer.key] !== false}
                  disabled={collapsed}
                  onChange={() => onToggleLayer(layer.key)}
                  type="checkbox"
                />

                <span>{layer.label}</span>
              </label>
            ))}
          </div>

          <div className="map-layer-panel__group">
            {categories.map((category) => {
              const key = `poi:${category.value}`;
              const count =
                poiSummary.byCategory?.[category.value] || 0;

              return (
                <label
                  className="map-layer-toggle"
                  key={category.value}
                >
                  <input
                    checked={layers[key] === true}
                    disabled={collapsed}
                    onChange={() => onToggleLayer(key)}
                    type="checkbox"
                  />

                  <span
                    aria-hidden="true"
                    className="map-layer-toggle__swatch"
                    style={{
                      backgroundColor: category.markerColor,
                    }}
                  />

                  <span>{category.label}</span>

                  <small>{count}</small>
                </label>
              );
            })}
          </div>

          {!categories.length && (
            <p className="map-layer-panel__empty">
              Tidak ada kategori POI tersedia.
            </p>
          )}

          {categories.length > 0 && poiCount === 0 && (
            <p className="map-layer-note">
              Tidak ada POI aktif di area rute ini.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}